export const environment = {
  production: false,
  localAPIUrl: 'https://dev.quickseries.com',
  strapiApiUrl: 'https://website-api-dev.quickseries.com',
  authorizationBearer: 'Bearer ce766da1152de6c09ee871e26811d7098b9cd6767986119860f59f96f9e4dbf2874093b053fbdbb0e59f60b1e820cf616c504346f3648a36011047968fc19ae54f2e5503b50bdc64b71013214ac0d4e44101013d976e7872ed44d16a4cf5ae3353288c482e5d264dbc44dd7db102293f019f9ced351ec596b5ba54f3d04f76af',
  algoliaAppId: '0FHOBUJUKQ',
  algoliaApiKey: '0a306fb5da2e21eb4d151c06c501efc8',
  googleApiKey: 'AIzaSyBzSYIGMGJthRU87kFKq82jnufk7oRGoT8',
  recaptchaKey: '6Len1CYpAAAAALJnrol3k7S2RhtP_pJuBnka4P26',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
